"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    checkCurrentUserTraits: function() {
        return checkCurrentUserTraits;
    },
    dynamicTraitsProperties: function() {
        return dynamicTraitsProperties;
    },
    extendedProperties: function() {
        return extendedProperties;
    },
    getCurrentSubDomain: function() {
        return getCurrentSubDomain;
    },
    removedReservedKeywordProperties: function() {
        return removedReservedKeywordProperties;
    },
    removedUselessEventProperties: function() {
        return removedUselessEventProperties;
    },
    removedUselessPageProperties: function() {
        return removedUselessPageProperties;
    }
});
var _define_property = require("@swc/helpers/_/_define_property");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var _constants = require("./constants");
var _constants1 = require("../../constants");
var _cookie = require("../../helpers/cookie");
var removePropertiesFromObject = function(object, ignoredProperties) {
    return Object.keys(object).reduce(function(acc, key) {
        if (ignoredProperties.includes(key)) {
            return acc;
        }
        return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, object[key]));
    }, {});
};
var getCurrentSubDomain = function(hostname) {
    var subdomainMatch = hostname.match(_constants1.SUBDOMAIN_REGEXP);
    return (subdomainMatch === null || subdomainMatch === void 0 ? void 0 : subdomainMatch[1]) || "";
};
var dynamicTraitsProperties = {
    get session_subdomain () {
        return getCurrentSubDomain(window.location.hostname);
    },
    get visitor_id () {
        return (0, _cookie.getCookie)("visitor_id") || "";
    },
    get jt_session_id () {
        return (0, _cookie.getCookie)("jobteaser_session") || "";
    }
};
var checkCurrentUserTraits = function(currentTraits) {
    var propsToBeUpdated = Object.entries(dynamicTraitsProperties).filter(function(param) {
        var _param = _sliced_to_array._(param, 2), prop = _param[0], value = _param[1];
        return currentTraits[prop] && value !== currentTraits[prop];
    }).map(function(param) {
        var _param = _sliced_to_array._(param, 1), prop = _param[0];
        return prop;
    });
    return {
        propsToBeUpdated: propsToBeUpdated,
        mustBeUpdated: propsToBeUpdated.length > 0
    };
};
var removedReservedKeywordProperties = function(payload) {
    return removePropertiesFromObject(payload, _constants.RESERVED_KEYWORD_PROPERTIES);
};
var removedUselessPageProperties = function(payload) {
    var ignoredProperties = _to_consumable_array._(_constants.RESERVED_KEYWORD_PROPERTIES).concat(_to_consumable_array._(_constants.IGNORED_GLOBAL_PROPERTIES));
    return removePropertiesFromObject(payload, ignoredProperties);
};
var removedUselessEventProperties = function(payload) {
    var ignoredProperties = _to_consumable_array._(_constants.RESERVED_KEYWORD_PROPERTIES).concat(_to_consumable_array._(_constants.IGNORED_GLOBAL_PROPERTIES), _to_consumable_array._(_constants.IGNORED_EVENT_PROPERTIES));
    return removePropertiesFromObject(payload, ignoredProperties);
};
var extendedProperties = function(payload, locale) {
    return _object_spread._({}, payload, locale ? {
        trackee_locale: locale
    } : null);
};

//# sourceMappingURL=utils.js.map